module.exports = __webpack_public_path__ + "static/berger-ipad-b0df088870442831bbfbcb6a2da65b76.jpg";